import { environment } from "../../../environments/environment";

export const domain = environment.domain
export const allLanguages = [
    // {
    //   name: "Arabic",
    //   native_name: "عربي",
    //   value: "ar",
    //   flag: "ar",
    //   hreflang: "ar",
    // },
    {
        name: "Bulgarian",
        native_name: "български",
        value: "bg",
        flag: "bg",
        hreflang: "bg",
    },
    {
        name: 'English',
        native_name: 'English',
        value: 'en',
        flag: 'en',
        hreflang: "en",
    },
    // {
    //   name: "Chinese (simplified)",
    //   native_name: "中文（简体）",
    //   value: "zh-hans",
    //   flag: "cn",
    //   hreflang: "zh-hans",
    // },
    // {
    //   name: "Chinese (traditional)",
    //   native_name: "中文（繁體）",
    //   value: "zh-hant",
    //   flag: "cn",
    //   hreflang: "zh-hant",
    // },
    // {
    //   name: "Czech",
    //   native_name: "čeština",
    //   value: "cs",
    //   flag: "cs",
    //   hreflang: 'cs',
    // },
    // {
    //   name: "Dutch",
    //   native_name: "Nederlands",
    //   value: "nl",
    //   flag: "nl",
    //   hreflang: "nl"
    // },
    // {
    //   name: "Filipino",
    //   native_name: "Filipino",
    //   value: "fil",
    //   flag: "fil",
    //   hreflang: "fil"
    // },
    // {
    //   name: "Finnish",
    //   native_name: "suomalainen",
    //   value: "fi",
    //   flag: "fi",
    //   hreflang: "fi"
    // },
    // {
    //   name: "French",
    //   native_name: "Français",
    //   value: "fr",
    //   flag: "fr",
    //   hreflang: "fr"
    // },
    // {
    //   name: "German",
    //   native_name: "Deutsch",
    //   value: "de",
    //   flag: "de",
    //   hreflang: "de",
    // },
    // {
    //   name: "Greek",
    //   native_name: "ελληνικά",
    //   value: "el",
    //   flag: "el",
    //   hreflang: "el"
    // },
    // {
    //   name: "Hungarian",
    //   native_name: "magyar",
    //   value: "hu",
    //   flag: "hu",
    //   hreflang: "hu"
    // },
    // {
    //   name: "Indonesian",
    //   native_name: "Indonesia",
    //   value: "id",
    //   flag: "id",
    //   hreflang: "id"
    // },
    // {
    //   name: "Italian",
    //   native_name: "Italiano",
    //   value: "it",
    //   flag: "it",
    //   hreflang: "it"
    // },
    {
        name: "Japanese",
        native_name: "日本語",
        value: "ja",
        flag: "ja",
        hreflang: 'ja',
    },
    // {
    //   name: "Korean",
    //   native_name: "한국어",
    //   value: "ko",
    //   flag: "ko",
    //   hreflang: "ko",
    // },
    //  {
    //     name: "Norwegian",
    //     native_name: "norsk",
    //     value: "no",
    //     flag: "no",
    //     hreflang: "no",
    //   },
    // {
    //   name: "Polish",
    //   native_name: "Polski",
    //   value: "pl",
    //   flag: "pl",
    //   hreflang: "pl",
    // },
    // {
    //   name: "Portuguese",
    //   native_name: "Português",
    //   value: "pt",
    //   flag: "pt",
    //   hreflang: "pt",
    // },
    // {
    //   name: "Romanian",
    //   native_name: "română",
    //   value: "ro",
    //   flag: "ro",
    //   hreflang: "ro",
    // },
    // {
    //   name: "Russian",
    //   native_name: "Русский",
    //   value: "ru",
    //   flag: "ru",
    //   hreflang: "ru",
    // },
    // {
    //   name: "Slovak",
    //   native_name: "slovenský",
    //   value: "sk",
    //   flag: "sk",
    //   hreflang: "sk",
    // },
    // {
    //   name: 'Slovenian',
    //   native_name: 'slovenščina',
    //   value: 'sl',
    //   flag: 'sl',
    //   hreflang: 'sl'
    // },
    // {
    //   name: "Spanish",
    //   native_name: "Español",
    //   value: "es",
    //   flag: "es",
    //   hreflang: "es",
    // },
    // {
    //   name: "Swedish",
    //   native_name: "svenska",
    //   value: "sv",
    //   flag: "sv",
    //   hreflang: "sv"
    // },
    // {
    //   name: "Thai",
    //   native_name: "แบบไทย",
    //   value: "th",
    //   flag: "th",
    //   hreflang: "th"
    // },
    // {
    //   name: "Turkish",
    //   native_name: "Türkçe",
    //   value: "tr",
    //   flag: "tr",
    //   hreflang: "tr",
    // },
    // {
    //   name: "Vietnamese",
    //   native_name: "Tiếng Việt",
    //   value: "vi",
    //   flag: "vi",
    //   hreflang: 'vi',
    // },
];
